import React, { ReactElement, useState } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { BottomSheet } from '@daedalus/atlas/BottomSheet';
import { Button } from '@daedalus/atlas/Button';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { PopUp } from '@daedalus/atlas/PopUp';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { OfferAlertVariant } from './constants';
import { offerAlertMessages, overlayTranslations } from './offerAlertMessages';
import { VariantComponent } from './VariantComponent';
type PropsTypes = {
  matchedOfferPriceDiff?: number | undefined;
  currency?: string;
  variant: OfferAlertVariant;
  penalty?: ReactElement;
};
const _exp = /*#__PURE__*/() => Text;
const OverlayContent = /*#__PURE__*/styled(_exp())({
  name: "OverlayContent",
  class: "om3yj04",
  propsAsIs: true
});
const _exp7 = /*#__PURE__*/() => Button;
const ButtonWrapper = /*#__PURE__*/styled(_exp7())({
  name: "ButtonWrapper",
  class: "b1bxmis5",
  propsAsIs: true
});
export const OfferAlertBanner = ({
  matchedOfferPriceDiff,
  currency,
  variant,
  penalty
}: PropsTypes) => {
  const [isReasonOverlayOpen, setIsReasonOverlayOpen] = useState(false);
  const absolutePrice = matchedOfferPriceDiff && Math.abs(matchedOfferPriceDiff);
  const {
    isMobile
  } = useDeviceLayout();
  const isPerksVariant = variant === OfferAlertVariant.CancellationPenalty || variant === OfferAlertVariant.Meal;
  const {
    content,
    centerContent
  } = overlayTranslations[isPerksVariant ? 'perks' : 'price'];
  const renderFooterContent = () => {
    if (isPerksVariant) {
      return <ButtonWrapper variant="secondary" fullWidth onClick={() => setIsReasonOverlayOpen(false)} className={cx(isMobile && 'isMobile')}>
          <FormattedMessageWrapper {...offerAlertMessages.dealUpdatedButton} />
        </ButtonWrapper>;
    }
    return null;
  };
  return <>
      <VariantComponent variant={variant} onClick={() => setIsReasonOverlayOpen(true)} price={absolutePrice} currency={currency} penalty={penalty} />
      {isMobile ? <BottomSheet isOpen={isReasonOverlayOpen} onClose={() => setIsReasonOverlayOpen(false)} titleBarProps={{
      centerContent: <FormattedMessageWrapper {...centerContent} />
    }} footerContent={renderFooterContent()}>
          <OverlayContent variant="bodyM">
            <FormattedMessageWrapper {...content} />
          </OverlayContent>
        </BottomSheet> : <PopUp titleBarProps={{
      centerContent: <FormattedMessageWrapper {...centerContent} />
    }} isOpen={isReasonOverlayOpen} closeAction={() => setIsReasonOverlayOpen(false)} width={640} footer={renderFooterContent()}>
          <OverlayContent variant="bodyM" className="isDesktop">
            <FormattedMessageWrapper {...content} />
          </OverlayContent>
        </PopUp>}
    </>;
};

require("./OfferAlertBanner.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./OfferAlertBanner.tsx");